import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-style-guide-uswds',
    templateUrl: './style-guide-uswds.component.html',
    styleUrls: ['./style-guide-uswds.component.css'],
    standalone: false
})
export class StyleGuideUswdsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
